import {useEffect} from 'react';
import {useParams} from 'react-router-dom';

import {captureException} from '@zzng/common/utils/matrix';

import {TIARA_HOME_ACTION, TIARA_HOME_PAGE_NAME, TiaraAction} from '@/shared/constants/tiara';
import useTiara from '@/shared/hooks/useTiara';

type TiaraHomeAction = (typeof TIARA_HOME_ACTION)[keyof typeof TIARA_HOME_ACTION];

interface Props {
  pageView?: TiaraHomeAction | TiaraAction;
}

export const useHomeTiara = ({pageView}: Props) => {
  const tiara = useTiara({pageName: TIARA_HOME_PAGE_NAME.ISSUE});
  const {recommendCode = ''} = useParams<{recommendCode: string}>();

  const customProps = {
    recommend_code: recommendCode
  };

  const trackEvent = (action: TiaraHomeAction | TiaraAction) => {
    tiara.trackEvent({action, customProps});
  };

  useEffect(() => {
    if (!recommendCode) {
      captureException(`recommendCode가 없습니다.`);
    }

    if (pageView) {
      tiara.trackPage({action: pageView, customProps});
    }
  }, []);

  return {trackEvent};
};

export default useHomeTiara;
